import _ from 'underscore';

import Module from '../../core/module';
import TaskFilter from '../../view/tasks.filter';
import Tasks from '../../collection/tasks';
import TasksModule from './list';
import ScheduleFormModule from '../schedule/form';
import ScheduleTemplatesModule from '../schedule/templates.list';
import Sublist from '../../view/module/tasks/sublist';

import { TaskNew, newTask } from '../../view/task.new';
import { fetch } from '../../collection/comments';
import { ask, } from '../../utils/popups';
import { promisify, } from '../../utils/promisify';
import { del, } from '../../http/api';
import { delay, } from '../../utils/promisify';
import { hashify } from '../../utils/arrays';
import { beginLock, endLock } from '../../loader';
import { CircleBlue, PinRed, PinGray, TaskIcon, PinGreen, PinBlue } from '../../view/map.icons';





export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        const opts = () => {
            const { 
                layers, datatables, clusters,
                types, organizations, contracts,
                statuses, priorities, fields, 
                serviceObjectMappings,
                locationService
            } = options;

            return { 
                layers, datatables, clusters,
                locationService,
                types, organizations, contracts,
                statuses, priorities,
                fields,
                serviceObjectMappings, 
            };
        };

        this.options.actions = {
            
            defaults: 'edit',
        
            multitask: () =>
                promisify( newTask( new TaskNew( opts() ), opts().priorities ) )
                    .then( ({ task }) => {
                        if (task.point || task.lon && task.lat)
                            return this.fetchAndUpdateLayers();
                    } ),
            
            edit: (current) =>
                this.trigger( TasksModule.OPEN_TASK, current ),
            
            destroy: {
            
                disabled: (current) => 
                    !current || !current.capabilities_.delete,
                
                handler: (current) =>
                    ask( 'issue::modal delete - confirmation text', undefined, 'actions::yes', 'actions::no',
                        () => del( `/tasks/${current.id}` ).blocking( this ).cerebellum().execute() )
                        .then( () => this.fetchAndUpdateLayers() ),
            }
    
        };

        this.options.issues = new Tasks( [], {
            endpoint: 'tasks/bbox?apiVersion=2.1&sortBy=id&sortDirection=DESC&maxClusters=25&limit=100000',
            responseAt: 'tasks',
            actions: this.options.actions,

            // override to avoid picking up the first row as active row
            restoreActive() {
                if (!this.activeId || this.activeRow() == undefined)
                    this.deactivate();
            },
        } );

        this.setState( {
            filters: TaskFilter.defaultFilters(),
        } );

        // this.commentsChannel = CommentsLive
        //     .filter( message => message instanceof Insert )
        //     .forEach( message => this.trigger( 'comments:income', message.model ) ); // model === attrs of Model
    },

    template: 'jst/module.tasks.map',

    url() {
        return 'map';
    },

    open() {
        return this.render()
            // need this delay to make fitBounds below work correctly
            .then( () => delay( 500 ) )
            .then( () => this.Filter.bind( new TaskFilter.Model( this.state().filters ) ) )
            .then( () => {
                const { map } = this.state();
                if (map && map.bounds) 
                    this.Map.fitBounds( ...map.bounds );
            } )
            .then( () => delay( 500 ) )
            .then( () => {
                const {
                    _northEast: { lat: maxlat, lng: maxlon },
                    _southWest: { lat: minlat, lng: minlon }
                } = this.Map.bounds();
                this.setState( { 
                    map: {
                        bounds: [minlat, minlon, maxlat, maxlon],
                    }
                } );
            } )
            .then( () => {
                const { popup } = this.state();
                if (!popup)
                    return this.fetchAndUpdateLayers();

                const subList = this.createListPopup(
                    popup.filters.bbox,
                    popup.page || 1,
                    popup.activeId );

                return Promise.all( [this.fetchAndUpdateLayers(), subList.fetching] )
                    .then( () => subList );
            } )
            .then( subList => {
                const current = this.options.issues.current();
                if (current)
                    this.fetchCurrentComments();
    
                this.setState( { 
                    activeId: current ? current.id : undefined,
                } );

                return this.Toolbar.render()
                    .then( () => current && this.Task.bind( current ) ) 
                    .then( () => [this, subList] )
            } );
    },

    start(subList) {
        const { issues } = this.options;
        let lastFiltering = Promise.resolve();

        // issues.plugActionSource( this.Grid );

        // this.listenTo( this.Search, 'search', queryString => 
        //     lastFiltering = lastFiltering
        //         .then( () => {
        //             this.setState( { queryString, } );
        //             this.navigated();
        //             return issues.filter( getHttpFilters( this.state() ) );
        //         } )
        //         .catch( () => undefined ) );

        // if (issues.current())
        //     this.Comments.bind( issues.current() );

        this.Map
            .onMoveOrZoom( _.debounce( () => {
                this.fetchAndUpdateLayers(); 
                const {
                    _northEast: { lat: maxlat, lng: maxlon },
                    _southWest: { lat: minlat, lng: minlon }
                } = this.Map.bounds();
                this.setState( { 
                    map: {
                        bounds: [minlat, minlon, maxlat, maxlon]
                    }
                } );
                this.navigated();
            }, 500 ) );

        this.Map.listenTo( issues, 'activate deactivate', 
            () => {
                const current = issues.current();
                if (current)
                    this.Task.bind( current ), this.fetchCurrentComments();
                else
                    this.Task.unbind();

                const activeId = current ? current.id : undefined;
                if (this.state().activeId != activeId)
                    this.setState( { activeId, } ), this.navigated();
            } );

        // this.listenTo( this, 'comments:income',
        //     comment => handleIncomingComment.call( this, comment ) );

        this.Filter.focus();

        if (subList)
            this.openPopupList( subList );
    },

    stop() {
        const { issues } = this.options;

        this.stopListening( this.Filter );
        // this.stopListening( this, 'comments:income' );

        // this.Map.stopListening( issues );

        return this;
    },

    createListPopup(bbox, page = 1, activeId) {
        const view = new Sublist( {
            // ...not all state, but some props of it
            filters: {
                bbox,
                ...this.state().filters || {}
            },
            page,
            activeId
        } );

        const state = {
            filters: { bbox },
            page,
            activeId
        };

        return {
            view, state, 
            fetching: view.fetch()
        }
    },

    openPopupList({ view, state, fetching }) {
        this.setState( { popup: state } );
        this.navigated();

        this.listenTo( view, 'Paging:page', 
            page => {
                const { popup } = this.state();
                this.setState( {
                    popup: {
                        ...popup,
                        page
                    }
                } );
                this.navigated();
            } );

        this.listenTo( view, 'row', 
            activeId => {
                const { popup } = this.state();
                this.setState( {
                    popup: {
                        ...popup,
                        activeId
                    }
                } );
                this.navigated();
            } );

        beginLock( this );
        const rendering = fetching.then( () => view.render() )
            .finally( () => endLock( this ) )
            .then( () => view );

        ask( rendering, undefined, undefined, 'actions::close', {
            // 900px-wide
            medium: true,
            // arrow function to save "this"
            onOpen: ({ reject }) => {
                this.listenTo( view, 'edit',
                    task => {
                        this.trigger( TasksModule.OPEN_TASK, task );
                        // first initiate module-opening, 
                        // next call reject to close popup - 
                        // this combination will prevent removing
                        // popup from state-hash because 
                        // event-listening for closing popup is over
                        // before reject() call
                        reject();
                    } );
            }
        } )
            .finally( () => {
                this.stopListening( view );
                // remove information about popup from state-hash
                this.setState( {
                    popup: undefined
                } );
                this.navigated();
                this.fetchAndUpdateLayers();
            } );
    },

    serialize() {
        const { issues, locationService, } = this.options;

        return {
            queryString: this.state().queryString || '',
            actionList: issues.actions,
            collection: issues,
            locationService,
        };
    },

    events: {

        'keyup [name=title]'(e) {
            if (13 == e.keyCode)
                this.Grid.trigger( 'action:default' ),
                e.preventDefault();
        },

    },

    [Module.event( 'Filter:filter' )](filters) {
        this.setState( { filters, page: 1, /*activeId: undefined,*/ } );
        this.navigated();
        this.fetchAndUpdateLayers();
    },

    [Module.event( 'nav:list' )]() {
        this.trigger( TasksModule.OPEN_LIST, this.state() );
    },

    [Module.event( 'nav:contracts' )]() {
        this.trigger( TasksModule.OPEN_CONTRACTS, this.state() );
    },

    [Module.event( ':schedule:edit' )]({ id }) {
        return this.trigger( ScheduleFormModule.POPUP_EDIT, 
            // pass id only to force Schedule.byId in Form
            id );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => {
                this.options.issues.current().get( 'schedule' ).deleted = true;
                return this.Task.render();
            } );
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        return this.trigger( ScheduleTemplatesModule.POPUP, 
            // pass id only to force Schedule.byId in Template List
            id );
    },

    // [Module.event( 'Comments:comments:recalc-unread' )]() {
    //     this.Grid.render();
    // },

    requestCount_: 0,

    fetchAndUpdateLayers() {
        const requestId = ++this.requestCount_;

        const bounds = this.Map.bounds();
        const bbox = [
            bounds._southWest.lng, bounds._southWest.lat, 
            bounds._northEast.lng, bounds._northEast.lat];

        const degDist = bounds._northEast.lat - bounds._southWest.lat;
        const minDegDist = degDist * 1.5 * 48 / this.Map.$el.height();
        const minKmDist = 20000 * minDegDist / 180;

        const httpFilters = {
            ...Tasks.getHttpFilters( this.state() ),
            bbox,
            minD: minKmDist
        };

        return this.options.issues
            .filter( httpFilters, 1, this.state().activeId )
            .then( ([a, coll, { tasks, items }]) => {

                if (requestId != this.requestCount_)
                    return;

                const hash = hashify( 
                    coll.models.map( (task, index) => [task.id, index] ),
                    ([id, index]) => [id, index] );

                const clusters = items
                    .filter( cluster => cluster.count > 1 )
                    .map( ({ count, lon, lat, extent }) => ({ title: count, location: { lon, lat }, extent }) );

                const locations = tasks
                    .map( ({ task: { id, lon, lat }}) => ({ id, location: { lon, lat } }) );

                this.Map.updateLayer( 'clusters', 
                    this.Map.newClusterLayer( clusters, 
                        CircleBlue,
                        (marker, { extent }) => 
                            marker.on( 'click', () => {
                                const [x1, y1, x2, y2] = extent;
                                console.log( extent, x1 - x2, y1 - y2, this.Map.zoom() );
                                if (this.Map.zoom() >= 17)
                                    this.openPopupList( this.createListPopup( extent ) );
                                // 0.0005 grad ~= 50 meters on the equator
                                else if (Math.abs(x1 - x2) < 5e-4 && Math.abs(y1 - y2) < 5e-4)
                                    this.openPopupList( this.createListPopup( extent ) );
                                else
                                    return this.Map.spanToExtent_( extent ); 
                            } ) ) );
                this.Map.updateLayer( 'tasks', 
                    this.Map.newClusterLayer( locations, 
                        ({ id }) => {
                            const task = coll.at( hash[id] );
                            switch (task.get( 'stage' )) {
                                case 0: return PinGray();
                                case 1: return PinBlue();
                                case 2: return PinGreen();
                            }

                            return PinBlue();
                        },
                        (marker, attrs) => marker.on( 'click', 
                            (a, b) => {
                                this.options.issues.activate( hash[attrs.id] );
                                this.Map.updateLayer( 'activeTasks',
                                    this.Map.newClusterLayer( [attrs], PinRed ) );
                            } ) ) );
                this.Map.updateLayer( 'activeTasks',
                    this.Map.newClusterLayer( locations.filter( ({ id }) => id == this.state().activeId ),
                        PinRed ) );
            } );
    },

    fetchCurrentComments() {
        const current = this.options.issues.current();
        if (current && !current.comments_)
            return fetch( current.id ).then( ([json, coll]) =>
                current.trigger( 'comments:load', current.comments_ = json ) );
    }

}, {

} );



// WEBPACK FOOTER //
// ./src/js/module/tasks/map.js